import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.researcher.item');
import { OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import * as d3 from 'd3';

@Component({
    selector: 'wiz-page-researcher-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.researcher.item/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100vh;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.network-graph-container {
  position: relative;
  overflow: hidden;
  background: #fafbfc;
  background-image: radial-gradient(circle, #e2e8f0 1px, transparent 1px);
  background-size: 20px 20px;
}
.network-graph-container svg {
  display: block;
  width: 100%;
  height: 100%;
}

@media (min-width: 640px) {
  .network-graph-container {
    height: 600px !important;
  }
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.network-tooltip {
  transition: opacity 0.15s ease;
}`],
})
export class PageResearcherItemComponent implements OnInit, OnDestroy {
    @ViewChild('networkContainer') networkContainer: ElementRef;

    public loading: boolean = true;
    public researcher: any = null;
    public showAllKeywords: boolean = false;

    public tab: string = 'summary';
    public tabs: any[] = [
        { key: 'summary', label: '요약' },
        { key: 'publications', label: '성과물' },
        { key: 'network', label: '관계 네트워크' },
        { key: 'news', label: '관련 뉴스' }
    ];

    // Summary
    public summaryData: any = null;
    public summaryLoading: boolean = false;

    public pubRows: any[] = [];
    public pubTotal: number = 0;
    public pubSort: string = 'latest';
    public pubPage: number = 1;
    public pubDump: number = 20;
    public pubLoading: boolean = false;
    public pubSortOptions: any[] = [
        { key: 'latest', label: '최신순' },
        { key: 'oldest', label: '오래된순' }
    ];
    public pubPagination: any = { current: 1, start: 1, end: 1 };
    public docTypeMap: any = { paper: '논문', report: '보고서', patent: '특허' };
    public docTypeBadgeClass: any = {
        paper: 'bg-blue-50 text-blue-600',
        report: 'bg-emerald-50 text-emerald-600',
        patent: 'bg-violet-50 text-violet-600'
    };
    public pubFilter: string = 'all';
    public pubFilterOptions: any[] = [
        { key: 'all', label: '전체' },
        { key: 'paper', label: '논문' },
        { key: 'report', label: '보고서' },
        { key: 'patent', label: '특허' }
    ];
    public pubTypeCounts: any = {};

    public newsRows: any[] = [];
    public newsTotal: number = 0;
    public newsLoading: boolean = false;
    public newsHasMore: boolean = false;
    public newsStart: number = 1;
    public newsDisplay: number = 10;
    public newsQuery: string = '';
    public newsSort: string = 'relevance';
    public newsSortOptions: any[] = [
        { key: 'relevance', label: '관련도순' },
        { key: 'latest', label: '최신순' },
        { key: 'oldest', label: '오래된순' }
    ];

    // Network
    public networkLoading: boolean = false;
    public networkRefreshing: boolean = false;
    public networkData: any = null;
    public networkStats: any = null;
    public hoveredNode: any = null;
    public hoveredEdgeInfo: any = null;
    private networkSvg: any = null;
    private networkSimulation: any = null;
    private resizeObserver: ResizeObserver | null = null;
    private resizeDebounceTimer: any = null;
    private networkZoom: any = null;
    private networkCurrentTransform: any = null;
    private networkNodeSelection: any = null;
    public networkFilter: string = 'all';
    private networkLinkSelection: any = null;
    private networkEdges: any[] = [];

    private routerSub: Subscription | null = null;
    private researcherId: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.researcherId = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'summary';

        if (!this.researcherId) {
            this.loading = false;
            await this.service.render();
            return;
        }

        await this.loadDetail();

        if (this.tab === 'summary') {
            await this.loadSummary();
        }
        if (this.tab === 'publications') {
            await this.loadPublications();
        }
        if (this.tab === 'news') {
            await this.loadNews();
        }
        if (this.tab === 'network') {
            await this.loadNetwork();
        }

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                const newTab = WizRoute.segment.tab || 'summary';

                // 연구자 ID 변경 시 전체 리로드
                if (newId && newId !== this.researcherId) {
                    this.researcherId = newId;
                    this.tab = newTab;
                    this.summaryData = null;
                    this.pubRows = [];
                    this.pubTotal = 0;
                    this.pubPage = 1;
                    this.pubTypeCounts = {};
                    this.newsRows = [];
                    this.newsTotal = 0;
                    this.newsStart = 1;
                    this.destroyNetwork();
                    this.networkData = null;
                    this.networkStats = null;
                    this.hoveredNode = null;
                    this.hoveredEdgeInfo = null;

                    await this.loadDetail();
                    if (this.tab === 'summary') await this.loadSummary();
                    if (this.tab === 'publications') await this.loadPublications();
                    if (this.tab === 'news') await this.loadNews();
                    if (this.tab === 'network') await this.loadNetwork();
                    await this.service.render();
                    return;
                }

                // 탭만 변경
                if (newTab !== this.tab) {
                    this.tab = newTab;
                    if (this.tab === 'summary' && !this.summaryData) {
                        await this.loadSummary();
                    }
                    if (this.tab === 'publications' && this.pubRows.length === 0) {
                        await this.loadPublications();
                    }
                    if (this.tab === 'news' && this.newsRows.length === 0) {
                        await this.loadNews();
                    }
                    if (this.tab === 'network' && !this.networkData) {
                        await this.loadNetwork();
                    }
                    await this.service.render();
                    if (this.tab === 'network' && this.networkData) {
                        this.tryRenderNetwork();
                    }
                }
            }
        });

        await this.service.render();
        if (this.tab === 'network' && this.networkData) {
            this.tryRenderNetwork();
        }
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        this.destroyNetwork();
    }

    public async loadDetail() {
        this.loading = true;
        await this.service.render();

        let res = await wiz.call("detail", { researcher_id: this.researcherId });
        if (res.code === 200) {
            this.researcher = res.data;
        } else {
            this.researcher = null;
        }

        this.loading = false;
        await this.service.render();
    }

    public async changeTab(key: string) {
        if (this.tab === key) return;
        this.service.href(`/researcher/${this.researcherId}/${key}`);
    }

    public async goToPublicationsWithFilter(docType: string) {
        this.pubFilter = docType;
        this.pubPage = 1;
        this.pubRows = [];
        this.service.href(`/researcher/${this.researcherId}/publications`);
    }

    public async toggleKeywords(show: boolean) {
        this.showAllKeywords = show;
        await this.service.render();
    }

    public async loadSummary() {
        this.summaryLoading = true;
        await this.service.render();

        let res = await wiz.call("summary", { researcher_id: this.researcherId });
        if (res.code === 200) {
            this.summaryData = res.data;
        }

        this.summaryLoading = false;
        await this.service.render();
    }

    public openSummaryPublication(pub: any) {
        const urls: any = {
            paper: 'https://scienceon.kisti.re.kr/srch/selectPORSrchArticle.do?cn=',
            report: 'https://scienceon.kisti.re.kr/srch/selectPORSrchReport.do?cn=',
            patent: 'https://scienceon.kisti.re.kr/srch/selectPORSrchPatent.do?cn='
        };
        const baseUrl = urls[pub.doc_type];
        if (baseUrl && pub.doc_id) {
            window.open(baseUrl + encodeURIComponent(pub.doc_id), '_blank');
        }
    }

    public openSummaryNews(item: any) {
        if (item.link) {
            window.open(item.link, '_blank');
        }
    }

    public async loadPublications() {
        this.pubLoading = true;
        await this.service.render();

        let res = await wiz.call("publications", {
            researcher_id: this.researcherId,
            page: this.pubPage,
            dump: this.pubDump,
            sort: this.pubSort,
            doc_type: this.pubFilter
        });

        if (res.code === 200) {
            this.pubRows = res.data.rows || [];
            this.pubTotal = res.data.total || 0;
            if (res.data.counts) {
                this.pubTypeCounts = res.data.counts;
            }
            const totalPages = Math.ceil(this.pubTotal / this.pubDump);
            this.pubPagination = {
                current: this.pubPage,
                start: Math.floor((this.pubPage - 1) / 10) * 10 + 1,
                end: totalPages
            };
        }

        this.pubLoading = false;
        await this.service.render();
    }

    public async onPubSortSelect(key: string) {
        if (this.pubSort === key || this.pubLoading) return;
        this.pubSort = key;
        this.pubPage = 1;
        await this.loadPublications();
    }

    public async onPubPageMove(page: number) {
        if (this.pubLoading) return;
        this.pubPage = page;
        await this.loadPublications();
    }

    public async onPubFilterSelect(key: string) {
        if (this.pubFilter === key || this.pubLoading) return;
        this.pubFilter = key;
        this.pubPage = 1;
        await this.loadPublications();
    }

    public openPublication(pub: any) {
        const urls: any = {
            paper: 'https://scienceon.kisti.re.kr/srch/selectPORSrchArticle.do?cn=',
            report: 'https://scienceon.kisti.re.kr/srch/selectPORSrchReport.do?cn=',
            patent: 'https://scienceon.kisti.re.kr/srch/selectPORSrchPatent.do?cn='
        };
        const baseUrl = urls[pub.doc_type];
        if (baseUrl && pub.doc_id) {
            window.open(baseUrl + encodeURIComponent(pub.doc_id), '_blank');
        }
    }

    public async loadNews() {
        this.newsLoading = true;
        this.newsStart = 1;
        this.newsRows = [];
        await this.service.render();

        let res = await wiz.call("news", {
            researcher_id: this.researcherId,
            start: this.newsStart,
            display: this.newsDisplay,
            sort: this.newsSort
        });

        if (res.code === 200) {
            this.newsRows = res.data.rows || [];
            this.newsTotal = res.data.total || 0;
            this.newsHasMore = res.data.has_more || false;
            this.newsQuery = res.data.query || '';
        }

        this.newsLoading = false;
        await this.service.render();
    }

    public async loadMoreNews() {
        if (this.newsLoading || !this.newsHasMore) return;
        this.newsLoading = true;
        await this.service.render();

        this.newsStart += this.newsDisplay;
        let res = await wiz.call("news", {
            researcher_id: this.researcherId,
            start: this.newsStart,
            display: this.newsDisplay,
            sort: this.newsSort
        });

        if (res.code === 200) {
            this.newsRows = [...this.newsRows, ...(res.data.rows || [])];
            this.newsHasMore = res.data.has_more || false;
        }

        this.newsLoading = false;
        await this.service.render();
    }

    public openNews(item: any) {
        if (item.link) {
            window.open(item.link, '_blank');
        }
    }

    public async onNewsSortSelect(key: string) {
        if (this.newsSort === key || this.newsLoading) return;
        this.newsSort = key;
        await this.loadNews();
    }

    // ===================== Network =====================

    public async loadNetwork() {
        this.networkLoading = true;
        await this.service.render();

        let res = await wiz.call("network", { researcher_id: this.researcherId });
        if (res.code === 200) {
            this.networkData = { nodes: res.data.nodes || [], edges: res.data.edges || [] };
            this.networkStats = res.data.stats || {};
        }

        this.networkLoading = false;
        await this.service.render();
        this.tryRenderNetwork();
    }

    private tryRenderNetwork(retries: number = 15) {
        setTimeout(() => {
            const el = this.networkContainer?.nativeElement;
            if (el && el.clientWidth > 0 && this.networkData) {
                this.renderNetwork();
            } else if (retries > 0) {
                this.tryRenderNetwork(retries - 1);
            }
        }, 100);
    }

    private destroyNetwork() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        if (this.resizeDebounceTimer) {
            clearTimeout(this.resizeDebounceTimer);
            this.resizeDebounceTimer = null;
        }
        if (this.networkSimulation) {
            this.networkSimulation.stop();
            this.networkSimulation = null;
        }
        const container = this.networkContainer?.nativeElement;
        if (container) {
            d3.select(container).selectAll('svg').remove();
            d3.select(container).selectAll('.network-tooltip').remove();
        }
        this.networkSvg = null;
        this.networkZoom = null;
        this.networkCurrentTransform = null;
        this.networkNodeSelection = null;
        this.networkFilter = 'all';
        this.networkLinkSelection = null;
        this.networkEdges = [];
    }

    private renderNetwork() {
        if (!this.networkContainer || !this.networkData) return;

        this.destroyNetwork();

        const container = this.networkContainer.nativeElement;
        const width = container.clientWidth || 800;
        const height = container.clientHeight || 600;

        const nodes: any[] = this.networkData.nodes.map((n: any) => ({ ...n }));
        const edges: any[] = this.networkData.edges.map((e: any) => ({ ...e }));

        if (nodes.length === 0) return;

        // Weight 범위 계산 (ego 제외)
        const weights = nodes.filter((n: any) => !n.is_ego).map((n: any) => n.weight || 0);
        const maxWeight = Math.max(...weights, 1);
        const minWeight = Math.min(...weights, 0);

        // 노드 반지름: ego=40, 나머지 weight에 비례 24~36
        const radiusScale = d3.scaleLinear()
            .domain([minWeight, maxWeight])
            .range([24, 36]);

        nodes.forEach((n: any) => {
            n.radius = n.is_ego ? 40 : radiusScale(n.weight || 0);
        });

        // SVG
        const svg = d3.select(container).append('svg')
            .attr('width', width)
            .attr('height', height)
            .attr('viewBox', `0 0 ${width} ${height}`)
            .style('font-family', 'SUIT, sans-serif');

        this.networkSvg = svg;

        // Zoom
        const g = svg.append('g');
        const zoom = d3.zoom()
            .scaleExtent([0.2, 4])
            .on('zoom', (event: any) => {
                g.attr('transform', event.transform);
                this.networkCurrentTransform = event.transform;
            });
        svg.call(zoom as any);
        svg.on('dblclick.zoom', null);
        this.networkZoom = zoom;

        // Arrow marker
        g.append('defs').append('marker')
            .attr('id', 'arrow')
            .attr('viewBox', '0 -5 10 10')
            .attr('refX', 20)
            .attr('refY', 0)
            .attr('markerWidth', 6)
            .attr('markerHeight', 6)
            .attr('orient', 'auto')
            .append('path')
            .attr('d', 'M0,-5L10,0L0,5')
            .attr('fill', '#cbd5e1');

        // Tooltip (엣지 hover 전용 - 간단한 floating)
        const edgeTooltip = d3.select(container).append('div')
            .attr('class', 'network-tooltip')
            .style('position', 'absolute')
            .style('visibility', 'hidden')
            .style('background', 'white')
            .style('border', '1px solid #e2e8f0')
            .style('border-radius', '8px')
            .style('padding', '8px 12px')
            .style('font-size', '13px')
            .style('box-shadow', '0 4px 16px rgba(0,0,0,0.12)')
            .style('pointer-events', 'none')
            .style('z-index', '100')
            .style('max-width', '240px')
            .style('line-height', '1.5');

        const positionTooltip = (offsetX: number, offsetY: number) => {
            const tooltipNode = edgeTooltip.node() as HTMLElement;
            if (!tooltipNode) return;
            const tw = tooltipNode.offsetWidth;
            const th = tooltipNode.offsetHeight;
            let left = offsetX + 16;
            let top = offsetY - 10;
            if (left + tw > width) left = offsetX - tw - 16;
            if (top + th > height) top = height - th - 8;
            if (top < 0) top = 8;
            if (left < 0) left = 8;
            edgeTooltip.style('left', left + 'px').style('top', top + 'px');
        };

        // 엣지 weight 최대값 (link distance 역비례 계산용)
        const maxEdgeWeight = Math.max(...edges.map((e: any) => e.weight || 0), 1);

        // Force simulation
        const nodeCount = nodes.length;
        const minDistance = nodeCount <= 3 ? 200 : (nodeCount <= 6 ? 120 : 50);
        const simulation = d3.forceSimulation(nodes)
            .force('link', d3.forceLink(edges).id((d: any) => d.id).distance((d: any) => {
                const w = d.weight || 0;
                const baseDist = 200 - 150 * (w / maxEdgeWeight);
                return Math.max(baseDist, minDistance);
            }).strength(nodeCount <= 3 ? 0.3 : 0.4))
            .force('charge', d3.forceManyBody().strength(nodeCount <= 3 ? -800 : -500))
            .force('center', d3.forceCenter(width / 2, height / 2))
            .force('collision', d3.forceCollide().radius((d: any) => d.radius + (nodeCount <= 3 ? 40 : 8)));

        this.networkSimulation = simulation;

        // Ego 노드를 중앙에 고정
        const egoNode = nodes.find((n: any) => n.is_ego);
        if (egoNode) {
            egoNode.fx = width / 2;
            egoNode.fy = height / 2;
        }

        // 엣지 렌더
        const link = g.append('g')
            .selectAll('line')
            .data(edges)
            .enter().append('line')
            .attr('stroke', (d: any) => {
                if (d.type === 'inter') return '#fcd34d';
                return '#94a3b8';
            })
            .attr('stroke-width', 1.5)
            .attr('stroke-dasharray', (d: any) => {
                if (d.type === 'inter') return '4,4';
                return 'none';
            })
            .attr('stroke-opacity', 0.6);

        this.networkLinkSelection = link;
        this.networkEdges = edges;

        // 엣지 hover 영역 (투명한 넓은 선)
        const linkHover = g.append('g')
            .selectAll('line')
            .data(edges)
            .enter().append('line')
            .attr('stroke', 'transparent')
            .attr('stroke-width', 12)
            .style('cursor', 'pointer')
            .on('mouseover', (event: any, d: any) => {
                const typeLabels: any = { coauthor: '중심 연구자 ↔ 공동 저자', inter: '공동 저자 간 상호 관계' };
                let html = `<div style="font-weight:600;margin-bottom:4px;">관계: ${typeLabels[d.type] || d.type}</div>`;
                if (d.weight > 0) html += `<div>공동 논문 수: <strong>${d.weight}</strong>편</div>`;
                edgeTooltip.html(html).style('visibility', 'visible');
                positionTooltip(event.offsetX, event.offsetY);
            })
            .on('mousemove', (event: any) => {
                positionTooltip(event.offsetX, event.offsetY);
            })
            .on('mouseout', () => {
                edgeTooltip.style('visibility', 'hidden');
            });

        // 노드 그룹
        const node = g.append('g')
            .selectAll('g')
            .data(nodes)
            .enter().append('g')
            .style('cursor', 'pointer')
            .call(d3.drag()
                .on('start', (event: any, d: any) => {
                    if (!event.active) simulation.alphaTarget(0.3).restart();
                    d.fx = d.x;
                    d.fy = d.y;
                })
                .on('drag', (event: any, d: any) => {
                    d.fx = event.x;
                    d.fy = event.y;
                })
                .on('end', (event: any, d: any) => {
                    if (!event.active) simulation.alphaTarget(0);
                    if (!d.is_ego) {
                        d.fx = null;
                        d.fy = null;
                    }
                }) as any);

        // 노드 원 (브랜드 컬러: #0d7377 teal)
        node.append('circle')
            .attr('r', (d: any) => d.radius)
            .attr('fill', (d: any) => d.is_ego ? '#0d7377' : '#e0f2f1')
            .attr('stroke', (d: any) => d.is_ego ? '#0a5c5f' : '#80cbc4')
            .attr('stroke-width', (d: any) => d.is_ego ? 3 : 1.5)
            .transition().duration(600)
            .attr('fill', (d: any) => {
                if (d.is_ego) return '#0d7377';
                const intensity = maxWeight > 0 ? (d.weight || 0) / maxWeight : 0;
                return d3.interpolateRgb('#e0f2f1', '#0d7377')(intensity);
            });

        // 노드 텍스트 (전체 이름 표시)
        node.append('text')
            .attr('text-anchor', 'middle')
            .attr('dominant-baseline', 'central')
            .attr('fill', (d: any) => {
                if (d.is_ego) return 'white';
                const intensity = maxWeight > 0 ? (d.weight || 0) / maxWeight : 0;
                return intensity > 0.45 ? 'white' : '#0a5c5f';
            })
            .attr('font-size', (d: any) => {
                if (d.is_ego) return '13px';
                const name = d.name || '?';
                const maxWidth = d.radius * 1.6;
                const charWidth = 11;
                const fitSize = Math.floor(maxWidth / name.length * (charWidth / 10));
                return Math.max(9, Math.min(fitSize, 12)) + 'px';
            })
            .attr('font-weight', (d: any) => d.is_ego ? '700' : '500')
            .text((d: any) => d.name || '?');

        // Store references for resize
        this.networkNodeSelection = node;

        // 노드 호버 이벤트 (고정 정보 패널에 표시)
        node.on('mouseover', (event: any, d: any) => {
            // 엣지 정보 찾기
            let edgeInfo: any = null;
            if (!d.is_ego) {
                const edge = edges.find((e: any) => {
                    const src = typeof e.source === 'object' ? e.source.id : e.source;
                    const tgt = typeof e.target === 'object' ? e.target.id : e.target;
                    return (src === d.id || tgt === d.id);
                });
                if (edge) {
                    edgeInfo = {
                        type: edge.type,
                        weight: edge.weight,
                        publications: edge.publications || []
                    };
                }
            }
            this.hoveredNode = d;
            this.hoveredEdgeInfo = edgeInfo;
            this.service.render();

            // 연결된 엣지 강조
            link.attr('stroke-opacity', (l: any) => {
                const src = typeof l.source === 'object' ? l.source.id : l.source;
                const tgt = typeof l.target === 'object' ? l.target.id : l.target;
                return (src === d.id || tgt === d.id) ? 1 : 0.15;
            }).attr('stroke-width', (l: any) => {
                const src = typeof l.source === 'object' ? l.source.id : l.source;
                const tgt = typeof l.target === 'object' ? l.target.id : l.target;
                return (src === d.id || tgt === d.id) ? 2.5 : 1.5;
            });

            // 비연결 노드 흐리게
            const connectedIds = new Set<string>();
            connectedIds.add(d.id);
            edges.forEach((e: any) => {
                const src = typeof e.source === 'object' ? e.source.id : e.source;
                const tgt = typeof e.target === 'object' ? e.target.id : e.target;
                if (src === d.id) connectedIds.add(tgt);
                if (tgt === d.id) connectedIds.add(src);
            });
            node.style('opacity', (n: any) => connectedIds.has(n.id) ? 1 : 0.2);
        })
        .on('mousemove', () => {})
        .on('mouseout', () => {
            this.hoveredNode = null;
            this.hoveredEdgeInfo = null;
            this.service.render();
            this.applyFilterVisuals();
        })
        .on('click', (event: any, d: any) => {
            if (!d.is_ego && d.id) {
                this.service.href(`/researcher/${d.id}/summary`);
            }
        });

        // Tick
        simulation.on('tick', () => {
            link
                .attr('x1', (d: any) => d.source.x)
                .attr('y1', (d: any) => d.source.y)
                .attr('x2', (d: any) => d.target.x)
                .attr('y2', (d: any) => d.target.y);
            linkHover
                .attr('x1', (d: any) => d.source.x)
                .attr('y1', (d: any) => d.source.y)
                .attr('x2', (d: any) => d.target.x)
                .attr('y2', (d: any) => d.target.y);
            node.attr('transform', (d: any) => `translate(${d.x},${d.y})`);
        });

        // 초기 줌 fit
        const fitToView = () => {
            if (nodes.length <= 1) return;
            const padding = 60;
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
            nodes.forEach((n: any) => {
                if (n.x < minX) minX = n.x;
                if (n.y < minY) minY = n.y;
                if (n.x > maxX) maxX = n.x;
                if (n.y > maxY) maxY = n.y;
            });
            const dx = maxX - minX + padding * 2;
            const dy = maxY - minY + padding * 2;
            const curWidth = container.clientWidth || width;
            const curHeight = container.clientHeight || height;
            const maxScale = nodeCount <= 6 ? 1.0 : 1.5;
            const scale = Math.min(curWidth / dx, curHeight / dy, maxScale);
            const cx = (minX + maxX) / 2;
            const cy = (minY + maxY) / 2;
            svg.attr('width', curWidth).attr('height', curHeight)
                .attr('viewBox', `0 0 ${curWidth} ${curHeight}`);
            svg.transition().duration(500).call(
                (zoom as any).transform,
                d3.zoomIdentity.translate(curWidth / 2, curHeight / 2).scale(scale).translate(-cx, -cy)
            );
        };
        setTimeout(fitToView, 1500);

        // ResizeObserver: 컨테이너 크기 변경 시 SVG 크기 업데이트 + zoom re-fit
        this.resizeObserver = new ResizeObserver(() => {
            if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);
            this.resizeDebounceTimer = setTimeout(() => {
                if (!container || !svg.node()) return;
                const newW = container.clientWidth;
                const newH = container.clientHeight;
                if (newW <= 0 || newH <= 0) return;
                svg.attr('width', newW).attr('height', newH)
                    .attr('viewBox', `0 0 ${newW} ${newH}`);
                // ego 노드 중앙 재배치
                const ego = nodes.find((n: any) => n.is_ego);
                if (ego) {
                    ego.fx = newW / 2;
                    ego.fy = newH / 2;
                }
                simulation.force('center', d3.forceCenter(newW / 2, newH / 2));
                simulation.alpha(0.3).restart();
                // 시뮬레이션 안정화 후 zoom fit
                setTimeout(fitToView, 800);
            }, 200);
        });
        this.resizeObserver.observe(container);
    }

    public async applyNetworkFilter(type: string) {
        this.networkFilter = type;
        await this.service.render();
        this.applyFilterVisuals();
    }

    private applyFilterVisuals() {
        const link = this.networkLinkSelection;
        const node = this.networkNodeSelection;
        const edges = this.networkEdges;
        if (!link || !node || !edges.length) return;

        if (this.networkFilter === 'all') {
            link.attr('stroke-opacity', 0.6)
                .attr('stroke-width', 1.5);
            node.style('opacity', 1);
            return;
        }

        const filterType = this.networkFilter;
        const connectedIds = new Set<string>();

        edges.forEach((e: any) => {
            if (e.type === filterType) {
                const src = typeof e.source === 'object' ? e.source.id : e.source;
                const tgt = typeof e.target === 'object' ? e.target.id : e.target;
                connectedIds.add(src);
                connectedIds.add(tgt);
            }
        });

        link.attr('stroke-opacity', (l: any) => l.type === filterType ? 0.6 : 0.06)
            .attr('stroke-width', (l: any) => l.type === filterType ? 1.5 : 0.8);

        node.style('opacity', (n: any) => connectedIds.has(n.id) ? 1 : 0.2);
    }

    public async refreshNetwork() {
        this.networkRefreshing = true;
        this.destroyNetwork();
        await this.service.render();

        let res = await wiz.call("network", { researcher_id: this.researcherId });
        if (res.code === 200) {
            this.networkData = { nodes: res.data.nodes || [], edges: res.data.edges || [] };
            this.networkStats = res.data.stats || {};
        }

        this.networkRefreshing = false;
        await this.service.render();
        this.tryRenderNetwork();
    }

    public navigateToResearcher(id: string) {
        if (id) this.service.href(`/researcher/${id}/summary`);
    }
}

export default PageResearcherItemComponent;